const buttonStyles = {
  bottomButtonStyle: {
    height: '4.375rem',
    padding: '1.438rem',
    fontSize: '1.313rem'
  },
  homeButtonStyle: {
    height: '3.5rem',
    padding: '1rem',
    fontSize: '1.25rem'
  },
  bottomButtonRowStyle: {
    margin: '1.25rem 0 2.5rem 0',
    padding: '0 2.813rem',
    display: 'flex',
    justifyContent: 'space-between'
  },
  buttonWithCustomIconStyle: {
    height: '3.75rem',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center'
  }
}

export default buttonStyles
